import { useCallback, useEffect, useMemo } from "react";
import { useCoursesLoaderData } from "./coursesLoader.ts";
import useToasts from "../../../root/core-ui/toast/useToasts.ts";
import LaunchErrorToast from "../common/LaunchErrorToast.tsx";
import { useLayoutData } from "../layout/myCoursesLayoutLoader.ts";
import { useContentAccessFetcher } from "../actions/contentAccessAction.ts";
import { getReaderNavURL } from "../../../bookshelfLinks.ts";

export default function useLaunchBook(onDone?: () => void) {
  const { showToast } = useToasts();
  const courseData = useCoursesLoaderData();
  const { config } = useLayoutData();
  const fetcher = useContentAccessFetcher();

  const launchBook = useCallback(
    (path: string) => {
      return fetcher
        .submit(
          {
            path,
          },
          {
            action: `/my-courses/content-access`,
            method: "POST",
          }
        )
        .then((result) => {
          if (!result.data?.ok) {
            showToast(<LaunchErrorToast />);
            onDone?.();
          }
        })
        .catch(() => {
          showToast(<LaunchErrorToast />);
          onDone?.();
        });
    },
    [fetcher, showToast, onDone]
  );

  useEffect(() => {
    if (fetcher.state === "idle" && fetcher.data?.ok) {
      const vbid = fetcher.data?.data?.vbid;
      if (vbid) {
        window.location.href = getReaderNavURL(vbid);
      } else {
        showToast(<LaunchErrorToast />);
      }
      if (onDone) {
        onDone();
      }
    }
  }, [showToast, onDone, fetcher, courseData, config]);

  const isLaunchBookProcessing = fetcher.state !== "idle";

  return useMemo(
    () => ({
      isLaunchBookProcessing,
      launchBook,
    }),
    [isLaunchBookProcessing, launchBook]
  );
}
